import React from 'react'
import { Link } from 'react-router-dom'

function ServiceSidebar({ activeService, ctaTitle, ctaLabel }) {
    const services = [
        { path: '/service-cooperative', label: 'Online Co-operative Platform' },
        { path: '/service-micro-lending', label: 'Micro-Lending Services' },
        { path: '/service-tax-consulting', label: 'Tax Consulting Services' },
        {
            path: '/service-financial-reporting',
            label: 'Financial Reporting & Analysis',
        },
    ]

    return (
        <div className="service-sidebar">
            <div className="service-catagery-list wow fadeInUp">
                <h3>our services</h3>
                <ul>
                    {services.map((s) => (
                        <li key={s.path}>
                            <Link
                                to={s.path}
                                className={
                                    activeService === s.path ? 'active' : ''
                                }
                            >
                                {s.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div
                className="sidebar-cta-box wow fadeInUp"
                data-wow-delay="0.25s"
            >
                <div className="cta-box-content">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                        alt=""
                    />
                    <h3>{ctaTitle || 'Need Help? Contact Us'}</h3>
                </div>
                <div className="cta-contact-info">
                    <div className="cta-info-item">
                        <p>{ctaLabel || 'Need help!'}</p>
                        <h3>+234 705 803 0389</h3>
                    </div>
                    <div className="cta-info-item">
                        <p>E-mail now</p>
                        <h3>info@fidelanchor.com</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceSidebar
